import { render, staticRenderFns } from "./teamData.vue?vue&type=template&id=5c8db470&scoped=true"
import script from "./teamData.vue?vue&type=script&lang=js"
export * from "./teamData.vue?vue&type=script&lang=js"
import style0 from "./teamData.vue?vue&type=style&index=0&id=5c8db470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8db470",
  null
  
)

export default component.exports